<h2 mat-dialog-title>{{ data.title }}</h2>

<div mat-dialog-content class="pick-content">
  <mat-form-field appearance="outline" class="full">
    <mat-label>Suchen</mat-label>
    <input matInput [(ngModel)]="search" autocomplete="off" />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <div class="option-list">
    <button
      type="button"
      class="option-row"
      *ngFor="let o of filtered"
      [class.active]="isSelected(o.label)"
      (click)="pick(o.label)"
    >
      <mat-icon *ngIf="data.multi" class="check">
        {{ isSelected(o.label) ? 'check_box' : 'check_box_outline_blank' }}
      </mat-icon>
      <span class="label">{{ o.label }}</span>
      <mat-icon *ngIf="!data.multi && isSelected(o.label)" class="done">check</mat-icon>
    </button>
    <div class="empty" *ngIf="!filtered.length">Keine Treffer.</div>
  </div>

  <div class="create" *ngIf="data.createLabel">
    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ data.createLabel }}</mat-label>
      <input matInput [(ngModel)]="createText" (keydown.enter)="create()" autocomplete="off" />
    </mat-form-field>
    <button mat-stroked-button type="button" color="primary" [disabled]="!createText.trim()" (click)="create()">
      Hinzufügen
    </button>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="close()">Abbrechen</button>
  <button *ngIf="data.multi" mat-flat-button color="primary" type="button" (click)="confirmMulti()">
    Übernehmen
  </button>
</div>
